import { createAction, props } from '@ngrx/store';
import { User } from '../Authentication/auth.models';

//Profile Actions
export const profileUpdate = createAction('[Data] Profile Update', props<{ user: any }>());
export const profileUpdateSuccess = createAction('[Data] Profile Update Success', props<{ user: User }>());
export const profileUpdateFailure = createAction('[Data] Profile Update Failure', props<{ error: any }>());

//Profile Image
export const avatarUpdate = createAction('[Data] Avatar Update', props<{ avatar: File }>());
export const avatarUpdateSuccess = createAction('[Data] Avatar Update Success', props<{ user: User }>());
export const avatarUpdateFailure = createAction('[Data] Avatar Update Failure', props<{ error: any }>());

//Profile Image Deletion
export const avatarDeletion = createAction('[Data] Avatar Deletion');
export const avatarDeletionSuccess = createAction('[Data] Avatar Deletion Success', props<{ user: User }>());
export const avatarDeletionFailure = createAction('[Data] Avatar Deletion Failure', props<{ error: any }>());